import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'

type OpportunityData = PildomModules.Voirie.Data.OpportunityData

export class Opportunity extends BaseModel<OpportunityData> {
    override endPoint: string = 'voirie/opportunities'
    override translationKey: string = 'voirie.opportunities'
    override permissionName: string = 'voirie_opportunity'
    legendPictoUrl: string = 'voirie/map-legend/opportunities.png'
}
